import { render } from "./LocationReport.vue?vue&type=template&id=63aed533&scoped=true"
import script from "./LocationReport.vue?vue&type=script&lang=js"
export * from "./LocationReport.vue?vue&type=script&lang=js"

import "./LocationReport.vue?vue&type=style&index=0&id=63aed533&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63aed533"]])

export default __exports__